import { useNavigate } from 'react-router-dom'
import { useTenants } from '../../hooks/useTenants'
import { useTenantGroups } from '../../hooks/useTenantGroups'
import { TenantsTable } from '../../components/TenantsTable/TenantsTable'
import { ListEntityPage } from '../ListEntityPage/ListEntityPage'

export function TenantsPage() {
  const navigate = useNavigate()
  const {
    tenants,
    isLoading: tenantsLoading,
    error: tenantsError,
  } = useTenants()
  const {
    tenantGroups,
    isLoading: groupsLoading,
    error: groupsError,
  } = useTenantGroups()

  const isLoading = tenantsLoading || groupsLoading
  const error = tenantsError ?? groupsError

  return (
    <ListEntityPage
      title="Tenants"
      description="Each tenant belongs to one tenant group."
      loadingLabel="tenants"
      isLoading={isLoading}
      error={error}
      createHref="/tenants/create"
      createLabel="New tenant"
    >
      <TenantsTable
        tenants={tenants}
        tenantGroups={tenantGroups}
        onRowClick={(t) => navigate(`/tenants/${t.id}`)}
      />
    </ListEntityPage>
  )
}
